import cx from 'classnames';
import React from 'react';
import { getOnEnter } from '../../_utils';
import { Button } from '../../button';
import { Icon, IconColor, IconID, IconSize } from '../../icon';
import styles from './chip-base.module.scss';
/**
 * Returns prefix content for a chip based on its variant,
 * positioned left of the text.
 * Shows a drag handle icon for 'draggable'; otherwise, returns null.
 *
 * @param {Variant} variant
 * @returns {JSX.Element | null}
 */
export const getPrefixContent = (variant) => {
    switch (variant) {
        case 'draggable':
            return (React.createElement(Icon, { color: IconColor.GRAY, size: IconSize.SMALL, id: IconID.DRAG_HANDLE, className: styles.dragHandleIcon }));
        default:
            return null;
    }
};
export const renderCloseIcon = (variant, tooltip, handleClose) => {
    switch (variant) {
        case 'draggable':
            return (React.createElement("span", { "data-tooltip-content": tooltip, className: styles.closeIcon },
                React.createElement(Button, { icon: IconID.CROSS, onClick: handleClose, onKeyDown: getOnEnter(handleClose), size: "xs", type: "tertiary", tabIndex: handleClose ? 0 : -1 })));
        default:
            return (
            // eslint-disable-next-line jsx-a11y/control-has-associated-label
            React.createElement("span", { "data-tooltip-content": tooltip, onClick: handleClose, className: styles.closeIcon, role: "button", tabIndex: 0, onKeyDown: getOnEnter(handleClose) },
                React.createElement(Icon, { color: IconColor.GRAY, size: IconSize.MEDIUM, id: IconID.CROSS_CIRCLE })));
    }
};
export const getChipContent = (chipVariant, content, textContentClassNames, isCompactContent) => {
    // Returns prefix content (e.g., drag handle icon for 'draggable') or null if not needed.
    const prefixContent = getPrefixContent(chipVariant);
    const textContent = (React.createElement("span", { className: textContentClassNames, id: "chip-base-text-content" }, content.map((item, index) => {
        const uniqueKey = `${index}_${item === null || item === void 0 ? void 0 : item.text}_chip`;
        return (React.createElement("span", { key: uniqueKey, className: cx(styles.chipText, styles[item.style], {
                [styles.chipTextCompact]: isCompactContent,
            }) }, item.text));
    })));
    return (React.createElement(React.Fragment, null,
        prefixContent,
        textContent));
};
//# sourceMappingURL=chip-base-utils.js.map